import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createPortal } from 'react-dom';
export const Portal = ({
  children
}) => {
  const domNode = typeof document === 'object' ? document.getElementById('portal-root') : null;
  return domNode ? createPortal(children, domNode) : _jsx(_Fragment, {
    children: children
  });
};